var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{class:_vm.buttonClass,on:{"click":function($event){return _vm.emitOpen()}}},[_vm._t("default",[_vm._v(_vm._s(_vm.trans.get('profile:modal.report_profile.report_modal_show_button')))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }